module.exports = __webpack_public_path__ + "assets/tenBis-gov-logo-b08f64.svg";